/* sry-size-guide.js — interactive dress size selector for the product form.
   Markup comes from snippets/sry-size-guide.liquid; data below is the store's size chart. */
(function () {
  'use strict';

  // [US, UK, EU, bust in, bust cm, waist in, waist cm, hips in, hips cm, hollow-to-floor in, hollow-to-floor cm]
  var CHARTS = {
    standard: {
      title: 'Dress Size Chart',
      rows: [
        ['2', '6', '32', '32½', 83, '25½', 65, '35¾', 91, '58', 147],
        ['4', '8', '34', '33½', 84, '26½', 68, '36¾', 92, '58', 147],
        ['6', '10', '36', '34½', 88, '27½', 70, '37¾', 96, '59', 150],
        ['8', '12', '38', '35½', 90, '28½', 72, '38¾', 98, '59', 150],
        ['10', '14', '40', '36½', 93, '29½', 75, '39¾', 101, '60', 152],
        ['12', '16', '42', '38', 97, '31', 79, '41¼', 105, '60', 152],
        ['14', '18', '44', '39½', 100, '32½', 83, '42¾', 109, '61', 155],
        ['16', '20', '46', '41', 104, '34', 86, '44¼', 112, '61', 155]
      ]
    },
    plus: {
      title: 'Plus Size Dress Size Chart',
      rows: [
        ['16W', '20', '46', '43', 109, '36¼', 92, '45½', 116, '61', 155],
        ['18W', '22', '48', '45', 114, '38½', 98, '47½', 121, '61', 155],
        ['20W', '24', '50', '47', 119, '40¾', 104, '49½', 126, '61', 155],
        ['22W', '26', '52', '49', 124, '43', 109, '51½', 131, '61', 155],
        ['24W', '28', '54', '51', 130, '45¼', 115, '53½', 136, '61', 155],
        ['26W', '30', '56', '53', 135, '47½', 121, '55½', 141, '61', 155]
      ]
    }
  };
  var SYSTEMS = ['US', 'UK', 'EU'];
  var MEASURES = [
    { key: 'Bust', i: 3 },
    { key: 'Waist', i: 5 },
    { key: 'Hips', i: 7 },
    { key: 'Hollow to floor', i: 9 }
  ];

  function h(tag, cls, html) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (html != null) el.innerHTML = html;
    return el;
  }
  function fullName(row) {
    return 'US ' + row[0] + ' / UK ' + row[1] + ' / EU ' + row[2];
  }

  function init(root) {
    if (root.sryReady) return;
    root.sryReady = true;

    var save = root.getAttribute('data-save') === 'true';
    var state = { range: 'standard', system: 'US', unit: 'in', index: -1 };
    var q = function (s) { return root.querySelector(s); };
    var sizesEl = q('[data-sizes]'), cardEl = q('[data-card]'), chosenEl = q('[data-chosen]'),
        propEl = q('[data-prop]'), finderEl = q('[data-finder]'), resultEl = q('[data-result]'),
        dialog = q('[data-dialog]'), tablesEl = q('[data-tables]');

    function row() { return state.index < 0 ? null : CHARTS[state.range].rows[state.index]; }

    function setOn(group, value) {
      root.querySelectorAll('[' + group + ']').forEach(function (b) {
        var on = b.getAttribute(group) === value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on);
      });
    }

    function renderSizes() {
      var sys = SYSTEMS.indexOf(state.system);
      sizesEl.innerHTML = '';
      CHARTS[state.range].rows.forEach(function (r, i) {
        var b = h('button', 'sry-sg__size' + (i === state.index ? ' is-on' : ''), r[sys]);
        b.type = 'button';
        b.setAttribute('aria-pressed', i === state.index);
        b.setAttribute('aria-label', fullName(r));
        b.addEventListener('click', function () { state.index = i; render(); });
        sizesEl.appendChild(b);
      });
    }

    function renderCard() {
      var r = row();
      cardEl.hidden = !r;
      if (!r) {
        chosenEl.textContent = 'Select your size';
        propEl.disabled = true;
        propEl.value = '';
        return;
      }
      chosenEl.textContent = fullName(r);
      if (save) { propEl.disabled = false; propEl.value = fullName(r); }
      var off = state.unit === 'in' ? 0 : 1, suffix = state.unit === 'in' ? '″' : ' cm';
      q('[data-measures]').innerHTML = MEASURES.map(function (m) {
        return '<div class="sry-sg__measure"><span>' + m.key + '</span><strong>' + r[m.i + off] + suffix + '</strong></div>';
      }).join('');
    }

    function renderTables() {
      var off = state.unit === 'in' ? 0 : 1;
      tablesEl.innerHTML = Object.keys(CHARTS).map(function (name) {
        var c = CHARTS[name], sel = name === state.range ? state.index : -1;
        var line = function (label, get, head) {
          return '<tr><th scope="row">' + label + '</th>' + c.rows.map(function (r, i) {
            var cls = i === sel ? ' class="is-on"' : '';
            return head ? '<th scope="col"' + cls + '>' + get(r) + '</th>' : '<td' + cls + '>' + get(r) + '</td>';
          }).join('') + '</tr>';
        };
        return '<h4 class="sry-sg__table-title">' + c.title + '</h4><div class="sry-sg__table-wrap"><table class="sry-sg__table">' +
          '<thead>' + line('US size', function (r) { return r[0]; }, true) + '</thead><tbody>' +
          line('UK size', function (r) { return r[1]; }) + line('EU size', function (r) { return r[2]; }) +
          MEASURES.map(function (m) {
            return line(m.key + ' (' + (state.unit === 'in' ? 'inch' : 'cm') + ')', function (r) { return r[m.i + off]; });
          }).join('') + '</tbody></table></div>';
      }).join('');
    }

    function render() {
      setOn('data-range', state.range);
      setOn('data-system', state.system);
      setOn('data-unit', state.unit);
      renderSizes();
      renderCard();
      if (dialog.open) renderTables();
    }

    // smallest size whose bust, waist and hips all fit the entered measurements
    function findSize() {
      var factor = state.unit === 'in' ? 2.54 : 1, wanted = [], any = false;
      ['bust', 'waist', 'hips'].forEach(function (name, k) {
        var v = parseFloat(String(q('[data-in="' + name + '"]').value).replace(',', '.'));
        wanted[k] = isFinite(v) && v > 0 ? v * factor : null;
        if (wanted[k]) any = true;
      });
      if (!any) { resultEl.hidden = false; resultEl.textContent = 'Enter at least one measurement.'; return; }
      var found = null;
      ['standard', 'plus'].some(function (name) {
        return CHARTS[name].rows.some(function (r, i) {
          var fits = [4, 6, 8].every(function (col, k) { return wanted[k] == null || wanted[k] <= r[col] + 0.5; });
          if (fits) found = { range: name, index: i };
          return fits;
        });
      });
      resultEl.hidden = false;
      if (!found) {
        resultEl.textContent = 'Your measurements are outside this chart. Message our tailor on WhatsApp for a made-to-measure fit.';
        return;
      }
      state.range = found.range; state.index = found.index;
      render();
      resultEl.innerHTML = 'Your best fit is <strong>' + fullName(row()) + '</strong>. We have selected it for you.';
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-range')) { state.range = t.getAttribute('data-range'); state.index = -1; render(); }
      else if (t.hasAttribute('data-system')) { state.system = t.getAttribute('data-system'); render(); }
      else if (t.hasAttribute('data-unit')) { state.unit = t.getAttribute('data-unit'); render(); }
      else if (t.hasAttribute('data-finder-toggle')) {
        finderEl.hidden = !finderEl.hidden;
        t.setAttribute('aria-expanded', !finderEl.hidden);
      }
      else if (t.hasAttribute('data-find')) findSize();
      else if (t.hasAttribute('data-open-chart')) { renderTables(); if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); }
      else if (t.hasAttribute('data-close-chart')) { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); }
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog && dialog.close) dialog.close(); });
    // Enter inside the finder must not submit the add-to-cart form
    finderEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); findSize(); }
    });

    render();
  }

  function scan(node) {
    if (!node.querySelectorAll) return;
    if (node.matches && node.matches('[data-sry-size-guide]')) init(node);
    node.querySelectorAll('[data-sry-size-guide]').forEach(init);
  }
  function start() {
    scan(document);
    // quick view / quick shop load the product form later
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
